import { createSelector } from 'reselect';

const selectAccountWebPages = (state: any) => state.accountWebPages;


export const selectAccountWebPagesCurrentItem = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.current);

export const selectAccountWebPagesListItems = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.list);

export const selectSocialProfilesItemById = (itemId: any) =>
    createSelector(selectAccountWebPagesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountWebPagesQueryItems = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.query);

export const selectAccountWebPagesCreatedItem = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.create);

export const selectAccountWebPagesUpdatedItem = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.update);

export const selectAccountWebPagesReadItem = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.read);

export const selectAccountWebPagesDeletedItem = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.delete);

export const selectAccountWebPagesSearchedItems = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.search);

export const selectAccountWebPagesItemsCount = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.count);

export const selectAccountWebPagesItemsFilter = createSelector([selectAccountWebPages], (accountWebPages) => accountWebPages.filter);